import React from "react";
import { z } from "zod";

import { FormState } from "components/organisms/Form/types";

// context
import { usePyForm } from "../../../context";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type FormSubscribeProps<TSchema extends z.ZodType<any, any>, TSelected> = {
	id: string;
	selector: (state: FormState<TSchema>) => TSelected;
	children: (state: TSelected) => React.ReactNode;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const FormSubscribe = <TSchema extends z.ZodType<any, any>, TSelected = any>(
	props: FormSubscribeProps<TSchema, TSelected>
) => {
	const form = usePyForm<TSchema>();
	return (
		<form.Subscribe selector={props.selector}>
			{(state) => {
				return props.children(state);
			}}
		</form.Subscribe>
	);
};

export default FormSubscribe;
